const baseUrl = '/hubspot/token';
export const hubspotRoutes = {
  baseUrl: "".concat(baseUrl)
};